import { FormArray, FormGroup } from '@angular/forms';

import { BtAttendeeFormGroup } from '@app/shared/components/bt-get-ticket-panel/bt-get-ticket-panel.model';
import {
  IBtrPassportInfoApiModel,
  ICheckInLinkApiModel,
  IShortLinkApiModel,
} from './api/btr-passport-check-in-info.api.model';
import { BtrPassportModel } from './btr-passport.model';
import { PlaceModel } from './place.model';

export class BtrPassportCheckInInfoModel {
  checkInLink: CheckInLinkModel;
  passports: Array<BtrPassportModel> = [];
  passportsChecked: Array<
    BtrPassportModel & {
      checkinAttendeeFormArray?: FormArray<FormGroup<BtAttendeeFormGroup>>;
    }
  > = [];
  passportsNotSelfCheckin: Array<BtrPassportModel> = [];

  constructor(source?: IBtrPassportInfoApiModel) {
    if (source == null) {
      return;
    }
    this.checkInLink = new CheckInLinkModel(source.checkin_link);
    if (source.passports) {
      this.passports = source.passports
        ?.filter(item => !item.is_expired)
        ?.map(item => new BtrPassportModel(item));
    }
    if (source.passports_checked) {
      this.passportsChecked = source.passports_checked
        ?.filter(item => !item.is_expired)
        ?.map(item => new BtrPassportModel(item));
    }
    if (source.passports_not_self_checkin) {
      this.passportsNotSelfCheckin = source.passports_not_self_checkin.map(
        item => new BtrPassportModel(item),
      );
    }
  }

  static copyObj(
    source: Pick<
      BtrPassportCheckInInfoModel,
      keyof BtrPassportCheckInInfoModel
    >,
  ): BtrPassportCheckInInfoModel {
    return Object.assign(new BtrPassportCheckInInfoModel(), source);
  }

  removeCheckedPassport(id: string): void {
    this.passportsChecked = this.passportsChecked.filter(
      passport => passport.id !== id,
    );
  }
}

export class CheckInLinkModel {
  token: string;
  whiteLabelName: string;
  shortLink?: IShortLinkApiModel | null;
  isConfirmed?: boolean | null;
  link?: string | null;
  place?: PlaceModel | null;

  constructor(source?: ICheckInLinkApiModel) {
    if (source == null) {
      return;
    }
    this.token = source.token;
    this.whiteLabelName = source.white_label_name;
    this.shortLink = source.short_link ?? null;
    this.isConfirmed = source.is_confirmed ?? null;
    this.link = source.link ?? null;
    this.place = source.beacon ? new PlaceModel(source.beacon) : null;
  }

  static copyObj(
    source: Pick<CheckInLinkModel, keyof CheckInLinkModel>,
  ): CheckInLinkModel {
    return Object.assign(new CheckInLinkModel(), source);
  }
}
